import { useEffect, useState } from "react";
import { DashboardLayout } from "./_common/DashboardLayout";
import { pingstationListService, pingstationUpdateService } from "../utils/api";
import { notifyError, notifyInfo } from "../utils/notify";
import { useDispatch, useSelector } from "react-redux";
import { BiCheckDouble, BiRadar, BiSolidEditAlt } from "react-icons/bi";
import { Popup } from "./_common/Popup";

const columns = [
    {'airport_code': 'Airport Code'},
    {'pingstation_id': 'Pingstation ID'},
    {'lat': 'Latitude'},
    {'lon': 'Longitude'},
    {'altitude': 'Altitude'},
    {'active': 'Status'},
    {'version': 'Version'},
    {'created_at': 'Created At'},
    {'last_heard': 'Last Heard'},
];

const columnsInactive = [
    {'pingstation_id': 'Pingstation ID'},
    {'lat': 'Latitude'},
    {'lon': 'Longitude'},
    {'altitude': 'Altitude'},
    {'active': 'Status'},
    {'version': 'Version'},
    {'created_at': 'Created At'},
    {'last_heard': 'Last Heard'},
];

export function Pingstations() {
    // useState
    const [activePingstation, setActivePingstation] = useState([]);
    const [inactivePingstation, setInactivePingstation] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [activatePingstation, setActivatePingstation] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(new Date().toLocaleString());
    
    // const dispatch = useDispatch();

    // useSelector
    const user = useSelector((state) => state.user);

    const getPingstations = () => {
        pingstationListService((data) => {
            if (data.success) {
                setActivePingstation(data.active);
                setInactivePingstation(data.inactive);
                setLastUpdate(new Date().toLocaleString());
            } else {
                notifyError(data.message);
            }
        });
    }

    useEffect(() => {
        getPingstations();
    }, []);

    // Functions
    const onActivatePingstation = (station) => {
        setActivatePingstation(station);
        setIsPopupOpen(true);
    }

    const onCancelActivatePingstation = () => {
        setIsPopupOpen(false);
        setActivatePingstation(null);
    }

    const onActivatePingstationConfirm = () => {
        if (activatePingstation && isPopupOpen && user?.user?.id) {
            // Activate pingstation
            notifyInfo('Activating pingstation...');
            setIsPopupOpen(false);

            // Update pingstation
            pingstationUpdateService({ id: activatePingstation.id, active: true, activated_at: new Date(), activated_by: user?.user?.id }, (data) => {
                if (data.success) {
                    notifyInfo('Pingstation activated successfully');
                    getPingstations();
                } else {
                    notifyError(data.message);
                }
            });
        } else {
            notifyError('Unable to activate pingstation');
        }
    }

    const getStationVersion = (station) => {
        if (!station?.raw_status) {
            return 'N/A';
        }
        const parsedRaw = JSON.parse(station?.raw_status);
        return `${parsedRaw?.pingStationVersionMajor}.${parsedRaw?.pingStationVersionMinor}.${parsedRaw?.pingStationVersionBuild}`;
    }


    return <DashboardLayout route="/pingstations">
        <h1 className="text-4xl font-semibold">Pingstations <span className="text-sm text-gray-500">Last Updated: {lastUpdate}</span></h1>

        <h2 className="text-2xl font-semibold mt-6 text-gray-500">Active Pingstations</h2>
        {activePingstation && activePingstation.length ? <div className="bg-white shadow-sm mt-6">
            <table className="w-full border border-gray-300">
                <thead>
                    <tr className="bg-stone-200">
                        {columns.map((column, index) => (
                            <th key={index} className="border-b border-gray-300 px-4 py-2">
                                {Object.values(column)[0]}
                            </th>
                        ))}
                        <th className="border-b border-gray-300 px-4 py-2">VRS Link</th>
                        <th className="border-b border-gray-300 px-4 py-2">Edit</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-300 text-center text-sm">
                    {activePingstation.map((station, index) => (
                        <tr key={index} className="hover:bg-gray-100">
                            <td className="border-b border-gray-300 px-4 py-2">{station.airport_code}</td>
                            <td className="border-b border-gray-300 px-4 py-2">{station.pingstation_id}</td>
                            <td className="border-b border-gray-300 px-4 py-2">{station.lat}</td>
                            <td className="border-b border-gray-300 px-4 py-2">{station.lon}</td>
                            <td className="border-b border-gray-300 px-4 py-2">{Math.round(station.altitude / 1000)+"m"}</td>
                            <td className="border-b border-gray-300 px-4 py-2">{station.active ? 'Active' : 'Inactive'}</td>
                            <td className="border-b border-gray-300 px-4 py-2">{getStationVersion(station)}</td>
                            <td className="border-b border-gray-300 px-4 py-2">{new Date(station.created_at).toLocaleString()}</td>
                            <td className="border-b border-gray-300 px-4 py-2">{new Date(station.last_heard).toLocaleString()}</td>
                            <td className="border-b border-gray-300 px-4 py-2">
                                <a className="transition duration-300 text-2xl text-cyan-500 hover:text-gold-600 inline-block" href={`http://vrs.team-eagle.ca:8081/VirtualRadar/desktop.html?source=adew&lat=${station.lat}&lng=${station.lon}`} target="_blank" rel="noreferrer">
                                    <BiRadar style={{ color: 'inherit'}} />
                                </a>
                            </td>
                            <td className="border-b border-gray-300 px-4 py-2">
                                <a className="transition duration-300 text-2xl text-cyan-500 hover:text-gold-600" href={`/pingstation/edit/${station.id}`}>
                                    <BiSolidEditAlt style={{ color: 'inherit'}} />
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div> : <div className="mt-6 text-stone-600">No active pingstations</div>}

        {inactivePingstation && inactivePingstation.length ? <>
            <h2 className="text-2xl font-semibold mt-8 text-gray-500">Inactive Pingstations</h2>
            <div className="bg-white shadow-sm mt-6">
                <table className="w-full border border-gray-300">
                    <thead>
                        <tr className="bg-stone-200">
                            {columnsInactive.map((column, index) => (
                                <th key={index} className="border-b border-gray-300 px-4 py-2">
                                    {Object.values(column)[0]}
                                </th>
                            ))}
                            <th className="border-b border-gray-300 px-4 py-2">VRS Link</th>
                            <th className="border-b border-gray-300 px-4 py-2">Activate</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-300 text-center text-sm">
                        {inactivePingstation.map((station, index) => (
                            <tr key={index} className="hover:bg-gray-100">
                                <td className="border-b border-gray-300 px-4 py-2">{station.pingstation_id}</td>
                                <td className="border-b border-gray-300 px-4 py-2">{station.lat}</td>
                                <td className="border-b border-gray-300 px-4 py-2">{station.lon}</td>
                                <td className="border-b border-gray-300 px-4 py-2">{Math.round(station.altitude / 1000)+"m"}</td>
                                <td className="border-b border-gray-300 px-4 py-2">{station.active ? 'Active' : 'Inactive'}</td>
                                <td className="border-b border-gray-300 px-4 py-2">{getStationVersion(station)}</td>
                                <td className="border-b border-gray-300 px-4 py-2">{new Date(station.created_at).toLocaleString()}</td>
                                <td className="border-b border-gray-300 px-4 py-2">{new Date(station.last_heard).toLocaleString()}</td>
                                <td className="border-b border-gray-300 px-4 py-2">
                                    <a className="transition duration-300 text-2xl text-cyan-500 hover:text-gold-600 inline-block" href={`http://vrs.team-eagle.ca:8081/VirtualRadar/desktop.html?source=adew&lat=${station.lat}&lng=${station.lon}`} target="_blank" rel="noreferrer">
                                        <BiRadar style={{ color: 'inherit'}} />
                                    </a>
                                </td>
                                <td className="border-b border-gray-300 px-4 py-2">
                                    <button className="transition duration-300 text-2xl text-cyan-500 hover:text-gold-600" onClick={() => onActivatePingstation(station)}>
                                        <BiCheckDouble style={{ color: 'inherit'}} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </> : <div className="mt-6 text-stone-600">No inactive pingstations</div>}


        <Popup 
            isOpen={isPopupOpen}
            onClose={onCancelActivatePingstation}
            title="Activate Pingstation"
            message="Are you sure you want to activate this pingstation?"
            onConfirm={onActivatePingstationConfirm}
        />

    </DashboardLayout>
}